// extracted by mini-css-extract-plugin
export default {"imageContainer":"BusinessCard_imageContainer__R6p3l","openStatusButton":"BusinessCard_openStatusButton__xAl8F"};